import { gql } from "@apollo/client";

export const ADD_MUTATION = gql`
mutation($input: CreateInvoiceAttachmentInput!,$placementId:String!,$placementStatus:String!) {
  createInvoiceAttachment(placementId:$placementId,createInvoiceAttachmentInput: $input,placementStatus:$placementStatus) {
    message
    status
  }
}`

export const GET_ALL = gql`
query ($placementId:String!) {
  invoiceAttachments(placementId:$placementId) {
    id
    fileName
    activityReport
    attachmentType
    fileUrl
    amount
    invoiceNumber
    receivedDate
    uploadedBy {
      id
      firstName
      lastName
      fullName
    }
    placement {
      id
      placementId
    }
    invoiceEmailHistory{
      id
      emailTo
      ccTo
      bccTo
      emailType
      bodyContent
      createdAt
    }
    invoicePreSelectEmails{
      id
      email
      emailType
    }
    createdAt
    updatedAt
  }
}`

export const REMOVE_MUTATION = gql`
mutation($id:String!) {
  removeInvoiceAttachment(id: $id) {
    message
    status
  }
}`

export const UPDATE_MUTATION = gql`
mutation($input: UpdateInvoiceAttachmentInput!,$placementStatus:String!) {
  updateInvoiceAttachment(updateInvoiceAttachmentInput: $input,placementStatus:$placementStatus) {
    message
    status
  }
}`

export const EMAIL_MUTATION = gql`
mutation($placementId:String!,$input: InvoiceEmailInput!,$additionalFiles:[AdditionalFiles!],$scheduledDate:String) {
  sendEmail(placementId:$placementId,input: $input,additionalFiles:$additionalFiles,scheduledDate:$scheduledDate) {
    message
    status
  }
}`

export const UPDATE_SCHEDULED_EMAIL_MUTATION = gql`
mutation($invoiceStatusId:String!,$input: InvoiceEmailInput!,$scheduledDate:String!,$additionalFiles:[AdditionalFiles!]) {
  updateScheduledInvoiceEmail(invoiceStatusId:$invoiceStatusId,input: $input,scheduledDate:$scheduledDate,additionalFiles:$additionalFiles) {
    message
    status
  }
}`

export const GET_ALL_INVOICE_EMAIL_ATTACHMENTS = gql`
query($id:String!){
  getAllInvoiceEmailAttachments(id:$id){
    id,
    fileName:documentName
    source:documentUrl
  }
}`

export const GET_ALL_COMPANY_CONTACTS_EMAIL = gql`
query($companyId: String!) {
  getAllCompanyContactsAndRecruitersEmails(companyId: $companyId) {
    value
    label
  }
}
`